import { useEffect, useState, useRef } from 'react';

const AuthCallbackEmbedded = () => {
  const [status, setStatus] = useState('processing');
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;

    const handleCallback = () => {
      hasProcessed.current = true;

      console.log('🔄 Embedded AuthCallback');

      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const error = urlParams.get('error');
      const stateParam = urlParams.get('state');

      console.log('State Embedded:', stateParam);

      if (!stateParam) {
        console.error('❌ Missing state parameter');
        setStatus('error');
        return;
      }

      const stateData = JSON.parse(atob(stateParam));
      const { origin, host, shop } = stateData;

      if (error) {
        const errorData = { type: 'auth-error', error, host, shop };

        //** Try postMessage */
        try {
          if (window.opener && !window.opener.closed) {
            window.opener.postMessage(errorData, origin || '*');
            console.log('❌ Error sent via postMessage');
          } else {
            throw new Error('window.opener not available');
          }
        } catch (err) {
          console.log('Fallback to sessionStorage');
          sessionStorage.setItem('authResult', JSON.stringify(errorData));
        }

        setStatus('error-close');
        setTimeout(() => window.close(), 500);
        return;
      }

      if (code) {
        const successData = {
          type: 'auth-success',
          fullUrl: window.location.href,
          host,
          shop,
        };

        //** Try postMessage */
        try {
          if (window.opener && !window.opener.closed) {
            window.opener.postMessage(successData, origin || '*');

            console.log('✅ Success sent via postMessage');
          }
        } catch (err) {
          console.error('postMessage failed:', err);
        }

        sessionStorage.setItem('authResult', JSON.stringify(successData));

        setTimeout(() => {
          setStatus('success-close');
          try {
            window.close();
          } catch (err) {
            console.log('Cannot close window');
          }
        }, 300);
        return;
      }

      setStatus('error');
    };

    handleCallback();
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      {status === 'processing' && (
        <>
          <div style={{ fontSize: '50px' }}>⏳</div>
          <p style={{ marginTop: '20px', color: '#666' }}>Processing...</p>
        </>
      )}
      {status === 'success-close' && (
        <>
          <div style={{ fontSize: '50px', color: '#4CAF50' }}>✓</div>
          <p style={{ marginTop: '20px', color: '#666' }}>
            Success! You can close this window
          </p>
        </>
      )}
      {(status === 'error-close' || status === 'error') && (
        <>
          <div style={{ fontSize: '50px', color: '#f44336' }}>✗</div>
          <p style={{ marginTop: '20px', color: '#666' }}>
            Error. You can close this window
          </p>
        </>
      )}
    </div>
  );
};

export default AuthCallbackEmbedded;
